var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTelegram = function SvgTelegram(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4952 19.8686C17.5603 20.3545 17.9597 19.3364 17.9597 19.3364L20.7778 4.57362C20.7556 3.57863 19.4686 4.18025 19.4686 4.18025L3.69203 10.6361C3.69203 10.6361 2.93759 10.9137 3.00416 11.3997C3.07073 11.8856 3.66984 12.117 3.66984 12.117L7.64172 13.5053C7.64172 13.5053 8.83994 17.601 9.08402 18.3877C9.30592 19.1513 9.50562 19.1744 9.50562 19.1744C9.72751 19.267 9.92722 19.105 9.92722 19.105L12.5012 16.6754L16.4952 19.8686ZM17.1827 7.18812C17.1827 7.18812 17.7374 6.84103 17.7152 7.18812C17.7152 7.18812 17.804 7.23439 17.5155 7.55834C17.2492 7.83601 10.9697 13.7134 10.1265 14.5001C10.0599 14.5464 10.0155 14.6158 10.0155 14.7083L9.77145 16.8834C9.72707 17.1148 9.43861 17.1379 9.37204 16.9297L8.32914 13.3663C8.28476 13.2274 8.32914 13.0655 8.46228 12.9729L17.1827 7.18812Z",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgTelegram, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/telegram.a38898b6.svg";
export { ForwardRef as ReactComponent };